 ( function () {
     'use strict';
         jQuery.extend(true, e4.settings, {
             userContext: (function(){
                 var userContext = jQuery('body').data('shopContext');
                 return userContext;
             })(),
             require: {
                 lottie: {
                     url: 'https://cdnjs.cloudflare.com/ajax/libs/bodymovin/5.5.9/lottie.min.js',
                     fallback: 'https://cdnjs.cloudflare.com/ajax/libs/bodymovin/5.5.9/lottie.min.js',
                     callback: null
                 },
                 dawa: {
                     url: '//cdn.aws.dk/assets/dawa-autocomplete2/1.0.2/dawa-autocomplete2.min.js',
                     fallback: '//cdn.aws.dk/assets/dawa-autocomplete2/1.0.2/dawa-autocomplete2.min.js',
                     callback: null
                 },
                 dataTables: {
                     url: '//cdn.datatables.net/v/bs4/dt-1.11.3/date-1.1.1/r-2.2.9/sb-1.3.0/datatables.min.js',
                     fallback: '//cdn.datatables.net/v/bs4/dt-1.11.3/date-1.1.1/r-2.2.9/sb-1.3.0/datatables.min.js',
                     callback: null
                 },
                 summerNote: {
                     url: '//cdn.jsdelivr.net/npm/summernote@0.8.18/dist/summernote.min.js',
                     fallback: '//cdn.jsdelivr.net/npm/summernote@0.8.18/dist/summernote.min.js',
                     css: '//cdn.jsdelivr.net/npm/summernote@0.8.18/dist/summernote.min.css',
                     callback: function(){
                         jQuery('.js-summernote-editor').summernote({
                             height: 200,
                             toolbar: [
                                 ['style', ['style']],
                                 ['font', ['bold', 'underline', 'clear']],
                                 ['color', ['color']],
                                 ['para', ['ul', 'ol', 'paragraph']],
                                 ['table', ['table']]
                             ],
                             fontName: 'OpenSans'
                         });
                     }
                 }
             },
             relewise: {
                 search: {
                     url: '/system/data/relewise-search?q='
                 }
             },
             ecom:{
                 filters:{
                     cleanUrl: true
                 },
                 spotproduct: {
                     url: '/system/data/getspotproduct'
                 },
                 lazyload:{
                     buttonShowInterval: 4,
                     autoLoadCount: 12
                 },
                 cartFavorites: {
                     url: '/system/data/cart-favorites'
                 },
                 pdf: {
                     url: '/system/data/pdf-product',
                     fallback: '/system/data/pdf-product',
                     callback: null
                 },
                 pdfmakeUrl: {
                     url: '/files/templates/designs/juuls/_assets/js/vendor/pdfmake.min.js',
                     fallback: '//cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.62/pdfmake.js',
                     callback: null
                 },
                 vfsfontsUrl: {
                     url: '/files/templates/designs/juuls/_assets/js/vendor/vfs_fonts.js',
                     fallback: '//cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.62/vfs_fonts.js',
                     callback: null
                 },
                 htmlToPdfmake: {
                     url: '/files/templates/designs/juuls/_assets/js/vendor/html-to-pdfmake.js',
                     fallback: '//cdn.jsdelivr.net/npm/html-to-pdfmake/browser.js',
                     callback: null
                 }
             },
             search:{
                 result:{
                     pages:{
                         show: false
                     },
                     products: {
                         pagesize: 10
                     }
                 }
             }
         });

 }() );